import { hdImages } from "@/lib/hd-images";
import { Media } from "./Media";

import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "./ui/hover-card";

export const BenefitsGallery = () => {
  const benefits = [
    {
      src: hdImages.benefitTeam,
      alt: "Resuscitation team working in sync with datasyteAI™ role and timing cues",
      title: "Synchronized Team Workflow",
      description: "When every team member knows their role and timing, outcomes improve dramatically. datasyteAI™ provides real-time coordination cues.",
    },
    {
      src: hdImages.benefitTiming,
      alt: "Two-minute cycle timer prompting rhythm check and medication timing",
      title: "Precise Timing & Rhythm Checks",
      description: "Automated 2-minute cycle reminders for rhythm checks, medication administration, and CPR quality ensure protocol adherence.",
    },
    {
      src: hdImages.benefitSecurity,
      alt: "Structured, HIPAA-aligned code documentation captured automatically",
      title: "Secure Documentation",
      description: "HIPAA-compliant, audit-ready documentation captured automatically during the event, reducing post-code administrative burden.",
    },
  ];

  return (
    <section className="py-24 bg-accent/5 border-y border-border" id="benefits">
      <div className="container mx-auto px-6">
        <div className="eyebrow eyebrow-dot mb-4 reveal">Outcomes</div>
        <h2 className="section-title mb-3 reveal">What improves with datasyteAI™</h2>
        <p className="text-muted-foreground mb-12 reveal">
          Consistency that reflects your best practice—without adding noise.
        </p>

        <div className="grid md:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <HoverCard key={index} openDelay={200} closeDelay={100}>
              <HoverCardTrigger asChild>
                <div className="reveal overflow-hidden rounded-xl shadow-soft hover:-translate-y-2 transition-all duration-300 group cursor-pointer">
                  <Media
                    src={benefit.src}
                    alt={benefit.alt}
                    className="w-full h-[320px] object-cover group-hover:scale-105 transition-transform duration-500"
                  />

                </div>
              </HoverCardTrigger>
              <HoverCardContent className="w-80 bg-card/95 backdrop-blur-sm border-primary/20">
                <div className="space-y-2">
                  <h4 className="text-sm font-semibold text-primary">{benefit.title}</h4>
                  <p className="text-sm text-muted-foreground">{benefit.description}</p>
                </div>
              </HoverCardContent>
            </HoverCard>
          ))}
        </div>
      </div>
    </section>
  );
};
